import React from 'react';
import DropMenu from './DropMenu';
import { useNavigate } from "react-router-dom";
import { Typography, Badge, Avatar, Box, Stack, IconButton } from '@mui/material';

import {
    BsPersonCircle,
    BsFillGearFill,
    BsBoxArrowInLeft,
    BsBellFill,
    BsEnvelopeFill,
    BsList,BsPaletteFill
} from "react-icons/bs";
import SubMenus from '../pages/extra/SubMenus';

export default function MyToolBar({ user, onToggled, onLogout, appName, logo }) {
    const menuRight = React.useRef(null);
    const navigate = useNavigate();

    const items = [
        {
            label: user?.first_name
        },
        {
            label: <Typography sx={{ px: 1 }}>Profile</Typography>,
            icon: <BsPersonCircle fontSize="1em" color='green' />,
            command: () => navigate("/profile/")
        },
        {
            label: <Typography sx={{ px: 1 }}>Settings</Typography>,
            icon: <BsFillGearFill fontSize="1em" color='green' />,
            command: () => navigate("/settings/")
        },
        {
            label: <Typography sx={{ px: 1 }}>Logout</Typography>,
            icon: <BsBoxArrowInLeft fontSize="1em" color='red' />,
            command: () => onLogout?.()
        }
    ];

    const changeTheme = (newColor) => {
        const className = 'card-bg'; // existing class name

        const styleSheet = document.styleSheets[0];
        const rules = styleSheet.cssRules || styleSheet.rules;

        // Search for the rule by class name
        let ruleIndex = -1;
        for (let i = 0; i < rules.length; i++) {
            if (rules[i].selectorText === `.${className}`) {
                ruleIndex = i;
                break;
            }
        }

        const newStyle = `.${className} { background-color: ${newColor}; }`;

        if (ruleIndex !== -1) {
            // Rule exists — remove it and insert updated version
            styleSheet.deleteRule(ruleIndex);
            styleSheet.insertRule(newStyle, ruleIndex);
        } else {
            // Rule doesn't exist — just insert it
            styleSheet.insertRule(newStyle, styleSheet.cssRules.length);
        }

    }

    return (
        <Box
            className="ps-toolbar card-bg"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: 1,
                borderRadius: 2,
                width: '100%'
            }}
        >
            {/* Left - Toggle and Logo */}
            <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton onClick={onToggled}>
                    <BsList size={24} />
                </IconButton>
                <Box display="flex" alignItems="center">
                    <Typography sx={{ minWidth: 120 }} fontWeight={700} fontSize={14}>
                        {appName}
                    </Typography>
                </Box>
            </Stack>

            {/* Right - Icons and User Menu */}
            <Stack direction="row" spacing={2} alignItems="center">

                <SubMenus icon={<BsPaletteFill fontSize={16}/>}>
                    <Box display={'flex'} gap={1} sx={{p:1}}>
                        {["#efefef", "#baecd2","#d1e1f7","#fff7c0","#d2c3eb"].map((color) => <Box onClick={() => changeTheme(color)} sx={{ background: color, width: 20, height: 20, borderRadius: '100%' }}></Box>)}
                    </Box>
                </SubMenus>
                <Badge badgeContent={2} color="primary">
                    <BsBellFill size={16} />
                </Badge>
                <Badge variant="dot" color="error">
                    <BsEnvelopeFill size={16} />
                </Badge>
                <Box sx={{ position: 'relative' }}>
                    <DropMenu model={items} popup icon={<Avatar
                        src={user?.avatar}
                        alt={user?.first_name}
                        sx={{ cursor: 'pointer', width: 28, height: 28 }}
                    >
                        <Typography fontSize={12}>{user?.first_name?.slice(0, 2)?.toUpperCase()}</Typography>
                    </Avatar>} />
                </Box>
            </Stack>
        </Box>
    );
}
